import React, { forwardRef, InputHTMLAttributes } from 'react'
import classNames from 'classnames'
import { Icon } from '../Icon'
import { IconName } from '../Icon/types'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  stretch?: boolean
  border?: 'bottom' | 'full' | 'none'
  icon?: IconName
  error?: string
  label?: string
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ stretch, border = 'full', icon, error, label, className, ...props }, ref) => {
    const inputClasses = classNames(
      'bg-dark-bg-secondary text-white placeholder-dark-gray-primary',
      'focus:outline-none focus:ring-1 focus:ring-green transition-all',
      {
        'w-full': stretch,
        'border-b border-dark-border-primary': border === 'bottom',
        'border border-dark-border-primary rounded-lg': border === 'full',
        'border-none': border === 'none',
        'border-red': error,
        'pl-10': icon,
        'px-4 py-3': !icon,
        'pr-4 py-3': icon,
      },
      className
    )

    return (
      <div className={classNames('relative', { 'w-full': stretch })}>
        {label && (
          <label className="block text-sm text-dark-typo-gray mb-1">{label}</label>
        )}
        <div className="relative">
          {icon && (
            <div className="absolute left-3 top-1/2 -translate-y-1/2">
              <Icon name={icon} size={18} color="gray" />
            </div>
          )}
          <input ref={ref} className={inputClasses} {...props} />
        </div>
        {error && (
          <p className="text-red text-xs mt-1">{error}</p>
        )}
      </div>
    )
  }
)

Input.displayName = 'Input'
